import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { AIEnablementSource, ReadingAidsPopupPropsInState } from '../../types';

export enum AIDefinitionsActionType {
	UPDATE_STATE = 'UPDATE_STATE',

	UPDATE_KEYWORD_REGEX = 'UPDATE_KEYWORD_REGEX',

	UPDATE_KEYWORD_DECORATIONS_SESSION_ID = 'UPDATE_KEYWORD_DECORATIONS_SESSION_ID',

	UPDATE_KEYWORD_DECORATIONS = 'UPDATE_KEYWORD_DECORATIONS',

	OPEN_READING_AIDS_POPUP = 'OPEN_READING_AIDS_POPUP',

	CLOSE_READING_AIDS_POPUP = 'CLOSE_READING_AIDS_POPUP',

	READING_AIDS_POPUP_LOADED = 'READING_AIDS_POPUP_LOADED',
}

interface UpdateState {
	autoHighlightEnabled?: boolean;
	enabled?: boolean;
	enablementSource?: AIEnablementSource;
	type: AIDefinitionsActionType.UPDATE_STATE;
}

interface UpdateKeywordRegex {
	keywordRegex: RegExp;
	type: AIDefinitionsActionType.UPDATE_KEYWORD_REGEX;
}

interface UpdateSessionId {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS_SESSION_ID;
}

interface UpdateKeywordDecorations {
	keywordDecorations: DecorationSet;
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS;
}

interface OpenReadingAidsPopup {
	// there will be keywordId if opened by clicking decoration, there will be no keywordId if opened by AI define button
	keywordId?: string;
	readingAidsPopupProps: ReadingAidsPopupPropsInState;
	type: AIDefinitionsActionType.OPEN_READING_AIDS_POPUP;
}

interface CloseReadingAidsPopup {
	type: AIDefinitionsActionType.CLOSE_READING_AIDS_POPUP;
}

interface ReadingAidsPopupLoaded {
	type: AIDefinitionsActionType.READING_AIDS_POPUP_LOADED;
}

export type AIDefinitionsAction =
	| UpdateState
	| UpdateKeywordRegex
	| UpdateSessionId
	| UpdateKeywordDecorations
	| OpenReadingAidsPopup
	| CloseReadingAidsPopup
	| ReadingAidsPopupLoaded;
